import React from 'react';
import Panel from './Panel';
import SalesRegistration from '../../components/Panel/SalesRegistration/SalesRegistration';

const SalesRegistrationPage = (e) => {

  let servidor = (e.params.servidor === undefined ? false : true);
  return (
    <Panel>
      <div>
        <SalesRegistration isServidor={servidor} />
      </div>
    </Panel>

  );
};

export default SalesRegistrationPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/SalesRegistrationPage.js
 **/